import { render, staticRenderFns } from "./sectionBox.vue?vue&type=template&id=9f633d94&scoped=true"
import script from "./sectionBox.vue?vue&type=script&lang=js"
export * from "./sectionBox.vue?vue&type=script&lang=js"
import style0 from "./sectionBox.vue?vue&type=style&index=0&id=9f633d94&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f633d94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f633d94')) {
      api.createRecord('9f633d94', component.options)
    } else {
      api.reload('9f633d94', component.options)
    }
    module.hot.accept("./sectionBox.vue?vue&type=template&id=9f633d94&scoped=true", function () {
      api.rerender('9f633d94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/org/comps/sectionBox.vue"
export default component.exports